import { render, staticRenderFns } from "./ContextIconMenu.vue?vue&type=template&id=081655de&scoped=true"
import script from "./ContextIconMenu.vue?vue&type=script&lang=js"
export * from "./ContextIconMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081655de",
  null
  
)

export default component.exports